import { View } from "binder"
import { WorkingShift, WorkingShiftManipulationViewModel } from "./workingShiftManipulation-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";

export class WorkingShiftManipulationView extends View<WorkingShiftManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-545124D3-21EE-4390-AEB1-8EFA5D39CBB7"
    }
    loadHtml(): string {
        let element = require('./workingShiftManipulation.html').default;
        let style = require('./workingShiftManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set workingShifts(v: WorkingShift) { this._workingShifts = v; } public get workingShifts(): WorkingShift { return this._workingShifts; } private _workingShifts: WorkingShift;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
